import React, {useEffect, useState} from "react";
import {useDisclosure} from "@mantine/hooks";
import ajax from "../../../../services/AxiosInterceptor";
import {FileButton, Modal, TextInput} from "@mantine/core";
import {LoadingButton} from "../../../../components/loading_button/loading_button";

import {LoadingDiv} from "../../../../components/loading_div/loading_div";
import {BookUp2, Check, CreditCard, FileCheck, FileDown} from "lucide-react";
import {notifications} from "@mantine/notifications";
import env_config from "../../../../env_config";

export function ModaleUploadFirmware({product, titre}: {
    product: string,
    titre: string
}) {
    const [opened, handlers] = useDisclosure(false);
    const [btn_loading, set_btn_loading] = useState(false);

    const [fichier, setFichier] = useState<File|null>(null);
    const [version, setVersion] = useState("");
    const [manifest, setManifest] = useState<string|null>(null);

    // const [commercial_id, setCommercial_id] = useState<string|null>((capteur?.commercial?.id ? capteur?.commercial?.id + "" : null) ?? null);

    function handleEnregistrer() {
        const formData = new FormData();
        if (!fichier && version === "") {
            alert("Merci d'indiquer la version et uploader le fichier.");
            return
        }
        set_btn_loading(true);
        formData.append("version", version + "");
        if (fichier) formData.append("fichier", fichier);
        ajax.post("/otaadmin/"+product+"/firmware", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then(response => {
            notifications.show({
                withCloseButton: true,
                autoClose: env_config.notifications_duree_affichage,
                color: 'green',
                title: "Validé!",
                message: 'Le fichier est enregistré.',
                icon: <Check/>,
            });
            handlers.close();
            set_btn_loading(false);
        }).catch(error => {
            set_btn_loading(false);
        })
    }


    useEffect(() => {
        if (opened)
        {
            ajax.get("/otaadmin/"+product+"/firmware").then(res => {
                setManifest(res.data.manifest);
            }).catch(err => {})
        }
    }, [opened, product])

    return (
        <>

            <button style={{ margin: "unset" }} onClick={handlers.open}>
                <BookUp2 /> Firmware {titre}
            </button>

            <Modal opened={opened} onClose={() => {
                handlers.close()
                setManifest(null);
            }} title={"Firmware " + titre + " ("+product+")"}>

                {manifest === null ?
                    (
                        <LoadingDiv/>
                    )
                : (
                        <div className={"form"}>


                            <h3>manifest.json actuel:</h3>
                            <code className={"fullwidth"} style={{ width: "auto" }} >
                                <pre>{JSON.stringify(JSON.parse(manifest), null, 2)}</pre>
                            </code>

                            <h3>Upload nouveau firmware : </h3>

                            <TextInput
                                label={"Version"}
                                value={version}
                                onChange={e => {
                                    setVersion(e.target.value)
                                }}
                            />
                            <FileButton onChange={setFichier}>
                                {(props) => <button className={"" + (fichier?"vert":"sec")} {...props}>
                                    {fichier ? (
                                        <><FileCheck /> {fichier.name}</>
                                    ) : (<><FileDown /> firmware.bin</>)}
                                </button>}
                            </FileButton>


                            <LoadingButton is_loading={btn_loading} disabled={version === ""}
                                           onClick={handleEnregistrer} icone={"check"}>Enregistrer</LoadingButton>
                        </div>
                    )
                }



            </Modal>
        </>

    )
}